import React from 'react'
import { Badge } from 'react-bootstrap'

import { useNotificationsCount } from '../../../../hooks/useNotificationsCount'
import { usePermissions } from '../../../../hooks/usePermissions'
import { ROUTES } from '../../../../lib/routes'
import NavigationButton from '../../../misc/NavigationButton'
import NavigationButtonsContainer from '../../../misc/NavigationButtonsContainer'
import PageTitle from '../../../typography/PageTitle'

const ProfessionalNetworkPageHeader: React.FC = () => {
  const permissions = usePermissions()
  const notificationsCount = useNotificationsCount()

  return (
    <header className="d-flex flex-column flex-wrap align-items-start gap-3 column-gap-4 mb-4">
      <div className="">
        <PageTitle className="mb-none">Professional network</PageTitle>
      </div>

      <NavigationButtonsContainer className="flex-wrap">
        <NavigationButton
          to={ROUTES.professionalNetworkOnboarding}
          label="Onboarding"
        />

        <NavigationButton
          to={ROUTES.professionalNetworkRelationships}
          label={
            <div className="d-flex justify-content-center align-items-center gap-2">
              Your relationships
              {notificationsCount.relationships > 0 && (
                <Badge>{notificationsCount.relationships}</Badge>
              )}
            </div>
          }
        />

        <NavigationButton to={ROUTES.professionalNetworkStats} label="Stats" />

        <NavigationButton
          to={ROUTES.professionalNetworkRevenue}
          label="Revenue"
        />

        <NavigationButton
          to={ROUTES.professionalNetworkRequests}
          label={
            <div className="d-flex justify-content-center align-items-center gap-2">
              Approval requests
              {notificationsCount.approvalRequests > 0 && (
                <Badge>{notificationsCount.approvalRequests}</Badge>
              )}
            </div>
          }
        />

        <NavigationButton
          to={ROUTES.professionalNetworkApprovalManagement}
          label="Approval management"
        />

        <NavigationButton
          to={ROUTES.professionalNetworkLeadAdvisers}
          label="Lead advisers"
        />

        {permissions.canInviteToPanel && (
          <NavigationButton
            to={ROUTES.professionalNetworkInviteToRq}
            label="Invite to RQ"
          />
        )}

        {/* {permissions.canSearchPanels && (
          <NavigationButton
            to={ROUTES.addRelationship}
            label="Add a relationship"
          />
        )} */}
      </NavigationButtonsContainer>
    </header>
  )
}

export default ProfessionalNetworkPageHeader
